module.exports = __webpack_public_path__ + "building.b2e821c2.png";


//////////////////
// WEBPACK FOOTER
// ./client/images/building/full/building.png
// module id = 624
// module chunks = 0